import React, { useState, useContext, useEffect } from 'react'
import './Sequence.css'

import Parameter from './Parameter'
import DropZone from './DropZone'
import ParameterImage from './ParameterImage'
const data = [

    {
        id: 2073,
        question_id: 403,
        question_template_id: null,
        parent_answer_id: null,
        text: "ans",
        weight: 10,
        comment: null,
        order_number: 0,
        attachment_link: 'https://images.unsplash.com/photo-1571988840298-3b5301d5109b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8M3x8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=60',
        embed_url: "",
        children: [

        ]
    },
    {
        id: 2075,
        question_id: 403,
        question_template_id: null,
        parent_answer_id: null,
        text: "ans2",
        weight: 10,
        comment: null,
        order_number: 1,
        attachment_link: null,
        embed_url: "",
        children: [

        ]
    },
    {
        id: 2076,
        question_id: 403,
        question_template_id: null,
        parent_answer_id: null,
        text: "ans3",
        weight: 10,
        comment: null,
        order_number: 2,
        attachment_link: null,
        embed_url: "",
        children: [

        ]
    },
    {
        id: 2077,
        question_id: 403,
        question_template_id: null,
        parent_answer_id: null,
        text: "ans4",
        weight: 10,
        comment: null,
        order_number: 3,
        attachment_link: null,
        embed_url: "",
        children: [

        ]
    },
]

const Sequence = ({ setAnswers, options, currentAnswer }) => {
    const [allParameters, setAllParameters] = useState([])
    const [answersSequence, setAnswersSequence] = useState([])
    const [imageView, setImageView] = useState(false)

    useEffect(() => {
        if (!currentAnswer) {
            setAnswersSequence(new Array(options.length).fill({}))
            setAllParameters([...options])

        } else {
            const selectedSequence = []
            currentAnswer.forEach(element => {
                selectedSequence.push(options.find(opt => opt.id === element))
            });
            // console.log(selectedSequence)
            setAnswersSequence(selectedSequence)
            setAllParameters(options.filter(par => !currentAnswer.includes(par.id)))
        }
        setImageView(Boolean(options[0].attachment_link))
    }, [options]);

    // console.log(options)

    const handleDrop = (dropZone, item) => {
        console.log('dropZone', dropZone)
        console.log('item', item)


        let draggingChild = null
        let newUnselected = null
        let currentIndex = null
        if (item.startId == 'allParameters') {
            draggingChild = allParameters.find(child => child.id === item.id)
            // console.log(draggingChild)
            newUnselected = [...allParameters]
            currentIndex = allParameters.indexOf(draggingChild)
            const newAnswers = [...answersSequence]
            newUnselected.splice(currentIndex, 1)
            // newAnswers.s
            newAnswers[dropZone.path] = draggingChild
            console.log(newUnselected)
            setAllParameters(newUnselected)
            setAnswersSequence(newAnswers)
            // return
        } else {
            draggingChild = answersSequence.find(child => child.id === item.id)
            // console.log(answers[startParentIndex])
            currentIndex = answersSequence.indexOf(draggingChild)
            // console.log(currentIndex)
            const newAnswers = [...answersSequence]
            newAnswers[dropZone.path] = draggingChild
            newAnswers[currentIndex] = answersSequence[dropZone.path]


            setAnswersSequence(newAnswers)
            // return
        }

        return
    }
    useEffect(() => {
        setAnswers(answersSequence.map(a => a.id))
    }, [answersSequence]);

    console.log(answersSequence)

    const trancateText = (text) => {
        const maxLength = 25;
        const isLongText = text.text.length > maxLength;
        const truncatedText = isLongText 
            ? { ...text, text: `${text.text.slice(0, maxLength)}...` } 
            : text;
    
        return truncatedText;
    }

    return (
        <div className='sequence__container'>
            <div className='sequence__group'>
                {allParameters && allParameters.map((answer, index) => (
                    imageView ?
                        <ParameterImage option={answer} key={index} start={'allParameters'} />
                        :
                        <Parameter option={trancateText(answer)} fullText={answer} key={index} start={'allParameters'} />
                ))}
            </div>
            <div className='sequence__group'>
                {answersSequence.map((answer, index) => (
                    <React.Fragment key={index}>
                        {imageView ?
                            <div className='sequence__dropZoneContainerImage'>
                                <div className='sequence__answerNumber'>{index + 1}</div>
                                {!answer.attachment_link && <DropZone
                                    data={{
                                        path: index,
                                    }}
                                    onDrop={handleDrop}
                                >
                                </DropZone>}
                                {answer.attachment_link && <ParameterImage option={answer} start={index} />}

                            </div>
                            :
                            <div className='sequence__dropZoneContainer'>
                                <div className='sequence__answerNumber'>{index + 1}</div>
                               {!answer.text && <DropZone
                                    data={{
                                        path: index,
                                    }}
                                    onDrop={handleDrop}
                                >
                                </DropZone>}
                                {answer.text && <Parameter option={trancateText(answer)} start={index} fullText={answer} />}

                            </div>
                        }


                    </React.Fragment>
                ))}
            </div>
        </div>
    )

}

export default Sequence